
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import GetAppIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit,
    },
});

class CreateCsvFile extends Component {
    constructor(props) {
        super(props);
        this.createCsvFile = this.createCsvFile.bind(this);
    }

    createCsvFile() {
        var fileName = "HunterGame-Timesheet.csv";
        var data = getData(this.props.rows, this.props.data);

        var link = document.createElement("a");
        link.href = "data:application/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(data);
        link.download = fileName;
        link.click();
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <IconButton aria-label="Delete" className={classes.margin} onClick={event => this.createCsvFile()}>
                    <Tooltip title="Download CSV">
                        <GetAppIcon fontSize="small" />
                    </Tooltip>
                </IconButton>
            </div>
        )
    }
}

function getData(rows, data) {

    var header = '';
    for (var i = 0; i < rows.length; i++) {
        if (i < rows.length - 1) {
            header += rows[i].id + ',';
        }
        else {
            header += rows[i].id + '\n';
        }
    }

    var body = "";
    for (i = 0; i < data.length; i++) {
        var str = "";
        str += data[i].UserName + ","
        str += data[i].Date + ","
        str += data[i].Hours + ","
        str += data[i].SubCategoryName + ","
        str += data[i].ProjectName + ","
        str += data[i].TaskName + ","
        str += data[i].Notes.replace(/\n/g, ' ').replace(/,/g, ' ')+ ","
        str += data[i].Satisfaction + " " + convertSatisfaction(data[i].Satisfaction)

        body = body + str + "\n";
    }

    return header + body;
}

function convertSatisfaction(Satisfaction) {
    switch (Satisfaction) {
        case 0:
            return "😂😂😂"
        case 1:
            return "😄😄"
        case 2:
            return "😊"
        case 3:
            return "🤔"
        case 4:
            return "😠"
        case 5:
            return "😤😤"
        case 6:
            return "😡😡😡"
        default:
            return null
    }
}

CreateCsvFile.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateCsvFile);



// WEBPACK FOOTER //
// ./src/components/Timesheet/CreateCsvFile.js